import axios from 'axios';
import { ApiUrl } from '../services/ApiRest';
import React, { Component } from 'react'
import Cookies from 'universal-cookie';
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';
const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/"; //pasar id del estudiante
const idAdministrativo = cookie.get("idAdministrativo");    //declaramos una variable para usar la cookie del login


class SidebarDirectorPracticas extends Component {

    componentDidMount() {
        // Get que devuelve los datos de un estudiante recibiendo un id
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data;
                this.setState({ estudiante });
                //console.log(estudiante);
                cookie.set('nombres', estudiante.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', estudiante.apellidos_administrativo, { path: "/" })
            })
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (

            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav
                    className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft"
                    id="sidenavAccordion"
                >
                    <div className="sb-sidenav-menu px-2 pt-3">
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p className="text-white">Personal de Supervisor de Prácticas</p>
                        </div>

                        {/* Página Principal */}
                        <Link to="/directortitulacion" className="nav-link-custom">
                            <i className="fas fa-home me-2"></i>
                            Página Principal
                        </Link>

                       

                        {/* Gestión de Documentos */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseEstados"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-file-alt me-2"></i>
                                 Gestión de documentos
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseEstados">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/directorpracticas/gestiondocumentpractlab"
                                        className="nav-sub-link"
                                    >
                                        Gestión de documentos
                                    </Link>
                                   
                                </nav>
                            </div>
                        </div>
                         {/* Gestión de asignación de prácticas */}
                         <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseGestionAsig"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-file-alt me-2"></i>
                                 Gestión de asignación
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseGestionAsig">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/directorpracticas/gestionasignacion"
                                        className="nav-sub-link"
                                    >
                                        Asignación de Prácticas
                                    </Link>
                                </nav>
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/directorpracticas/gestionhoraspraccarrera"
                                        className="nav-sub-link"
                                    >
                                        Gestión de Horas Carrera
                                    </Link>
                                </nav>
                            </div>
                        </div>
                        {/* Gestión de entidades formadoras */}
                         <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseGestionEnt"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-file-alt me-2"></i>
                                 Gestión de Entidades
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseGestionEnt">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/directorpracticas/listaentidadpracticas"
                                        className="nav-sub-link"
                                    >
                                        Entidades Formadoras
                                    </Link>
                                </nav>
                            </div>
                        </div>
                      
                    </div>

                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario:<br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>
        )
    }
}

export default withRouter(SidebarDirectorPracticas);